module.exports = "../../app/cells/components/applied_exams/show.erb";